import { render } from "./CardAttachmentMediaImage.vue?vue&type=template&id=3e826ce7&scoped=true"
import script from "./CardAttachmentMediaImage.vue?vue&type=script&lang=js"
export * from "./CardAttachmentMediaImage.vue?vue&type=script&lang=js"

import "./CardAttachmentMediaImage.vue?vue&type=style&index=0&id=3e826ce7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e826ce7"]])

export default __exports__